// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"25062":"f66d4429738d4ece","53900":"9d0d9b532baa4cbc","92767":"9eaad40e7710b40f"}[chunkId] + ".css";
};